import React from "react"
import Svg from "../../utils/Svg"
import Path from "../../utils/Path"

const XSvg = ({ color = "primary", ...rest }) => {
  return (
    <Svg
      height="33"
      viewBox="-8.8 0 33 15"
      width="33"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <clipPath id="a">
        <Path d="m0 0h16v15h-16z" />
      </clipPath>
      <g clipPath="url(#a)">
        <Path
          d="m12.6009 0h2.4533l-5.35986 6.35395 6.30566 8.64605h-4.9374l-3.86694-5.24392-4.42475 5.24392h-2.455004l5.732964-6.79614-6.04887-8.20386h5.06247l3.4955 4.79301zm-.8611 13.4769h1.3595l-8.77546-12.03371h-1.45875z"
          fill={color}
        />
      </g>
    </Svg>
  )
}

export default XSvg
